export function computeReportAnalytics(enrichedRows = []) {
  let totalGst = 0;
  let totalBase = 0;
  let totalInclGst = 0;

  const channels = {};
  const gstByChannel = {};
  const statusBreakdown = {};

  (enrichedRows || []).forEach((row) => {
    totalGst += row.gst || 0;
    totalBase += row.amount || 0;
    totalInclGst += row.totalInclGst || 0;

    const chKey = row.channel || 'general';
    const chLabel = row.channelLabel || 'General';
    if (!channels[chKey]) {
      channels[chKey] = { key: chKey, label: chLabel, count: 0, credits: 0, debits: 0, gst: 0, base: 0 };
    }
    channels[chKey].count += 1;
    channels[chKey].credits += row.credit || 0;
    channels[chKey].debits += row.debit || 0;
    channels[chKey].gst += row.gst || 0;
    channels[chKey].base += row.amount || 0;

    if (!gstByChannel[chKey]) {
      gstByChannel[chKey] = { label: chLabel, taxableAmount: 0, gstAmount: 0, totalInclGst: 0, count: 0 };
    }
    gstByChannel[chKey].taxableAmount += row.amount || 0;
    gstByChannel[chKey].gstAmount += row.gst || 0;
    gstByChannel[chKey].totalInclGst += row.totalInclGst || 0;
    gstByChannel[chKey].count += 1;

    const st = row.statusLabel || 'Captured';
    statusBreakdown[st] = (statusBreakdown[st] || 0) + 1;
  });

  return {
    totalGst,
    totalBase,
    totalInclGst,
    channels: Object.values(channels).sort((a, b) => b.base - a.base),
    gstByChannel: Object.values(gstByChannel).sort((a, b) => b.gstAmount - a.gstAmount),
    statusBreakdown,
  };
}
